import styled from '@emotion/styled';
import media from '@shared/mediaQuery';
import { getStaticImageUrl } from '@utils/createImageUrl';

const FursysBenefit2Style = styled('div')`
  ${media.desktop} {
    width: 1080px;
    margin: auto;
  }

  .benfit {
    padding-top: 109px;
    font-family: 'Pretendard-Bold';
    font-size: 26px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #c1b3ac;
    background: url(${getStaticImageUrl({ fileName: 'index-02.png' })}) right 454px top 74px no-repeat;
    background-size: 78px 62px;
    ${media.desktop} {
      transform: translateX(-12px);
    }
    ${media.mobile} {
      padding-top: 89px;
      background: url(${getStaticImageUrl({ fileName: 'index-02.png' })}) right calc(50% - 26px) top 68px no-repeat;
      font-size: 16px;
      background-size: 49px 38px;
    }
  }

  .slidTitle {
    font-family: 'Pretendard-Bold';
    font-size: 38px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #faeeec;
    ${media.desktop} {
      margin-top: 20px;
      line-height: 52px;
    }
    ${media.mobile} {
      font-size: 29px;
      line-height: 37px;
      margin-top: 21px;
    }
  }
  .slideDescription {
    margin-top: 19px;
    margin-bottom: 31px;
    font-family: 'Pretendard-Regular';
    font-size: 18px;
    letter-spacing: -0.3px;
    text-align: center;
    color: #c1b3ac;
    ${media.mobile} {
      font-size: 14px;
      margin-top: 8px;
      margin-bottom: 22px;
      line-height: 20px;
    }
  }

  .fursysbrand {
    &--list {
      .slick-prev {
        &::before {
          display: none !important;
        }
      }
      .slick-next {
        &::before {
          display: none !important;
        }
      }
    }
    &--list-mobile {
      img {
        width: calc(100% - 40px);
        margin: auto;
        text-align: center;
      }
    }
    &--item {
      display: block !important;
    }
  }
  .slick-dots {
    ${media.mobile} {
      bottom: -21px;
      width: 100vw;
      padding: 0 20px;
      display: flex;
      justify-content: center;
      margin-left: -25px;
    }
    li {
      width: 10px;
      button:before {
        font-size: 30px;
        color: #ffffff;
      }
    }
  }
`;

export default FursysBenefit2Style;
